import { actions } from './actions'

const initialState = {
  banners: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  bannersDiasSemana: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  banner: {
    data: null,
    loading: false,
    error: '',
  },
  bannerConfiguracion: {
    data: false,
    loading: false,
    error: '',
  },
}

export default function bannersReducer(state = initialState, action) {
  switch (action.type) {
    case actions.BANNERS_LOAD_REQUESTED:
      return { ...state, banners: { ...state.banners, loading: true } }
    case actions.BANNERS_LOAD_SUCCEEDED:
      return {
        ...state,
        banners: { ...state.banners, data: action.payload, reload: false, loading: false },
      }
    case actions.BANNERS_LOAD_FILED:
      return {
        ...state,
        banners: { ...state.banners, loading: false, error: action.error },
      }
    case actions.BANNER_UPDATE_REQUESTED:
      return {
        ...state,
        banner: { ...state.banner, loading: true, error: '' },
      }
    case actions.BANNER_UPDATE_SUCCEEDED:
      return {
        ...state,
        banners: {
          ...state.banners,
          data: state.banners.data.map(banner =>
            banner.id === action.payload.id ? action.payload : banner,
          ),
          loading: false,
          error: '',
        },
        banner: { ...state.banner, data: action.payload, loading: false, error: '' },
      }
    case actions.BANNER_UPDATE_FILED:
      return {
        ...state,
        banner: { ...state.banner, loading: false, error: action.error },
      }
    case actions.BANNER_INSERT_REQUESTED:
      return {
        ...state,
        banner: { ...state.banner, loading: true, error: '' },
      }
    case actions.BANNER_INSERT_SUCCEEDED:
      return {
        ...state,
        banners: {
          ...state.banners,
          data: [].concat(action.payload, state.banners.data),
          loading: false,
          error: '',
        },
        banner: { ...state.banner, data: action.payload, loading: false, error: '' },
      }
    case actions.BANNER_INSERT_FILED:
      return {
        ...state,
        banners: { ...state.banners, loading: false, error: action.error },
        banner: { ...state.banner, loading: false, error: action.error },
      }
    case actions.BANNER_DELETE_REQUESTED:
      return {
        ...state,
        banners: { ...state.banners, loading: true, error: '' },
      }
    case actions.BANNER_DELETE_SUCCEEDED:
      return {
        ...state,
        banners: {
          ...state.banners,
          data: state.banners.data.filter(banner => banner.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.BANNER_DELETE_FILED:
      return {
        ...state,
        banners: { ...state.banners, loading: false, error: action.error },
      }
    case actions.BANNER_BYID_LOAD_REQUESTED:
      return {
        ...state,
        banner: { ...state.banner, loading: true, error: '' },
      }
    case actions.BANNER_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        banner: { ...state.banner, data: action.payload, loading: false, error: '' },
      }
    case actions.BANNER_BYID_LOAD_FILED:
      return {
        ...state,
        banner: { ...state.banner, data: null, loading: false, error: action.error },
      }
    case actions.BANNER_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        banner: { ...state.banner, data: null, loading: false, error: '' },
      }
    case actions.BANNER_ACTIVAR_UPDATE_REQUESTED:
      return {
        ...state,
        banners: { ...state.banners, loading: true, error: '' },
      }
    case actions.BANNER_ACTIVAR_UPDATE_SUCCEEDED:
      return {
        ...state,
        banners: {
          ...state.banners,
          loading: false,
          reload: true,
          error: '',
        },
      }
    case actions.BANNER_ACTIVAR_UPDATE_FILED:
      return {
        ...state,
        banners: { ...state.banners, loading: false, error: action.error },
      }
    case actions.BANNERS_DIAS_SEMANA_LOAD_REQUESTED:
      return { ...state, bannersDiasSemana: { ...state.bannersDiasSemana, loading: true } }
    case actions.BANNERS_DIAS_SEMANA_LOAD_SUCCEEDED:
      return {
        ...state,
        bannersDiasSemana: {
          ...state.bannersDiasSemana,
          data: action.payload,
          reload: false,
          loading: false,
        },
      }
    case actions.BANNERS_DIAS_SEMANA_LOAD_FILED:
      return {
        ...state,
        bannersDiasSemana: { ...state.bannersDiasSemana, loading: false, error: action.error },
      }
    case actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_REQUESTED:
      return { ...state, bannerConfiguracion: { ...state.bannerConfiguracion, loading: true } }
    case actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        bannerConfiguracion: { ...state.bannerConfiguracion, data: action.payload, loading: false },
      }
    case actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_FILED:
      return {
        ...state,
        bannerConfiguracion: { ...state.bannerConfiguracion, loading: false, error: action.error },
      }
    case actions.BANNER_SEMANA_UPDATE_REQUESTED:
      return {
        ...state,
        bannerConfiguracion: { ...state.bannerConfiguracion, loading: true, error: '' },
      }
    case actions.BANNER_SEMANA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bannerConfiguracion: {
          ...state.bannerConfiguracion,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.BANNER_SEMANA_UPDATE_FILED:
      return {
        ...state,
        bannerConfiguracion: { ...state.bannerConfiguracion, loading: false, error: action.error },
      }
    default:
      return state
  }
}
